<template>
	<el-tabs type="border-card" class="h-100">
		<el-tab-pane v-for="tab in tabs" :key="tab.index" :label="tab.label">
			<div class="h-100 compileBox">
				<sf-input-group
					class="h-100"
					:labelSpan="0"
					labelPosition="left"
					v-if="tab.index == 0"
					inputType="textarea"
					:inputValue="bindSql_"
					readonly
				/>
				<sf-input-group
					class="h-100"
					:labelSpan="0"
					labelPosition="left"
					v-if="tab.index == 1"
					inputType="textarea"
					:inputValue="staticSql_"
					readonly
				/>
				<log-table v-if="tab.index == 2" :historyRows="historyRows"></log-table>
			</div>
		</el-tab-pane>
	</el-tabs>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SQLEditor/store/helpers';
import LogTable from './LogTable.vue';

export default {
	components: {
		LogTable
	},
	props: {
		historyRows: { type: Array, default: () => [] }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		tabs() {
			return [
				{
					label: this.getMessage_('SWCC000749'),
					index: '0'
				},
				{
					label: this.getMessage_('SWCC000748'),
					index: '1'
				},
				{
					label: this.getMessage_('SWCC000747'),
					index: '2'
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods
	}
};
</script>
<style>
.compileBox {
	height: 100%;
}
.compileBox .sf-input-group-wrapper .el-row {
	height: 100% !important;
}
.compileBox .sf-input-group-wrapper .el-row .el-col {
	height: 100% !important;
}
.compileBox .sf-input-group-wrapper .el-row .el-col .el-textarea {
	height: 100% !important;
}
.compileBox .sf-input-group-wrapper .el-row .el-col .el-textarea .el-textarea__inner {
	height: 100% !important;
}
</style>
